import { unwrap, type WidgetDefinition } from "@nexus/widget-sdk";
import type { ProtectionOverviewCampaignEventsData } from "./types";
import { manifest, Component, defaultConfig } from ".";

export const definition: WidgetDefinition = {
  id: "protection-overview-campaign-events",
  module: { manifest, Component, defaultConfig },
  catalog: {
    description: "One campaign's protected events for one report edition, with drill-down.",
    domain: "reports",
    visual: "Carousel",
    purposes: ["reporting"],
    reportEdition: true,
    audiences: ["analyst", "client"],
  },
  layout: { skeleton: "cards" },
  // The campaign it lists the events of: the page's subject.
  subjects: (data) => {
    const campaign = unwrap<ProtectionOverviewCampaignEventsData>(data.events)?.campaign;
    return campaign
      ? [
          {
            kind: "campaign",
            id: campaign.id,
            label: campaign.label,
            ...(campaign.tenant ? { tenant: campaign.tenant } : {}),
          },
        ]
      : [];
  },
  defaultLayoutClassName: "col-span-12",
};
